export const objectToFormData = (values) => {
    var payload = new FormData();
    for (var key in values) {
        payload.append(key, values[key]);
    }
    return payload;
}


export const checkExistenceInBets = (id, bets) =>{
    console.log(id, "adsfsdfdsfdfg");

    // var bets = JSON.parse(localStorage.getItem("bets"));
    console.log(bets, "betsrfdfd");
    var flag = false;

    bets?.map((item)=>{
        if(item.id == id){
            flag = true;
        }    
    })

    return flag;
}